import { useI18n } from "../lib/i18n";
import { JOB_POSTING_LIMITS, jobPostingFieldError, type JobPostingField } from "../lib/jobPostingValidation";

// [jobs.listing-validation](../../../docs/product/jobs.md#jobs-listing-validation): the same guidance describes the Details and Review inputs;
// untouched empty titles show guidance rather than an immediate error.
export function JobFieldFeedback({ field, value, id, showEmptyError = false }: { field: JobPostingField; value: string; id: string; showEmptyError?: boolean }) {
  const { t } = useI18n();
  const errorKey = value || showEmptyError ? jobPostingFieldError(field, value) : null;
  const guidanceKey = errorKey || (field === "title" ? "posting.jobTitleHint" : "posting.jobTextLimitHint");
  return <div id={id} className="mt-1 flex flex-wrap items-start justify-between gap-x-3 gap-y-1 text-xs">
    <p className={errorKey ? "text-brand-reddark" : "text-mut"} role={errorKey ? "alert" : undefined}>
      {t(guidanceKey).replace("{limit}", JOB_POSTING_LIMITS[field].toLocaleString())}
    </p>
    <span className={`ml-auto shrink-0 tabular-nums ${errorKey ? "text-brand-reddark" : "text-mut"}`}>{value.length.toLocaleString()} / {JOB_POSTING_LIMITS[field].toLocaleString()}</span>
  </div>;
}
